import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/AppLayout';
import { Icon, PageHeader, BtnPrimary, BtnSecondary } from '../regureStyles';
import Table from './Table';
import Filters from './Filters';
import SummaryCards from './SummaryCards';
import NewReportModal from './NewReportModal';
import useComplianceFunctions from './useComplianceFunctions';


const ComplianceReportsScreen = () => {
  const { t } = useTranslation();
  const {
    reports,
    loading,
    search,
    setSearch,
    filterCategory,
    setFilterCategory,
    filterStatus,
    setFilterStatus,
    showNewForm,
    setShowNewForm,
    newReport,
    setNewReport,
    submitting,
    generating,
    categories,
    statuses,
    filtered,
    submitted,
    pending,
    dueThisMonth,
    handleCreate,
    handleGenerate,
    handleSubmit,
  } = useComplianceFunctions();

  return (
    <AppLayout>
      <div style={{ flex: 1, overflow: 'auto', padding: '32px 40px' }}>
        <PageHeader
          title={t('screens.compliance.title')}
          subtitle={t('screens.compliance.subtitle')}
          actions={
            <div style={{ display: 'flex', gap: 10 }}>
              <BtnSecondary>
                <Icon name='file-text' size={15} />
                {t('screens.compliance.export')}
              </BtnSecondary>
              <BtnPrimary onClick={() => setShowNewForm(true)}>
                <Icon name='plus' size={15} />
                {t('screens.compliance.newReport')}
              </BtnPrimary>
            </div>
          }
        />

        {/* Summary Cards */}
        <SummaryCards reports={reports} submitted={submitted} pending={pending} dueThisMonth={dueThisMonth} />

        {/* Filters */}
        <Filters
          search={search}
          setSearch={setSearch}
          filterCategory={filterCategory}
          setFilterCategory={setFilterCategory}
          categories={categories}
          filterStatus={filterStatus}
          setFilterStatus={setFilterStatus}
          statuses={statuses}
        />

        {/* Table */}
        <Table filtered={filtered} loading={loading} handleGenerate={handleGenerate} generating={generating} handleSubmit={handleSubmit} />
      </div>

      {/* New Report Modal */}
      {showNewForm && (
        <NewReportModal setNewReport={setNewReport} newReport={newReport} setShowNewForm={setShowNewForm} handleCreate={handleCreate} submitting={submitting} />
      )}
    </AppLayout>
  );
};

export default ComplianceReportsScreen;
